import React, { useRef } from 'react';
import TextField from 'material-ui/TextField';

const Search = (props) => {
    const searchInputRef = useRef(null);

    const onChangeInput = (value) => {
        props.changeSearch(value);
    };

    return (
        <div className='paper-block margin-10'>
            <span className='name-block absolute small-name'>Search areas</span>

            <TextField
                inputRef={searchInputRef}
                floatingLabelText='Find area'
                defaultValue=''
                onChange={e => onChangeInput(e.target.value)}
                fullWidth
            />
        </div>
    );
};

export default Search;



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/FilterAreas/Search.jsx